import { apm } from "@elastic/apm-rum";
import { Delete, KeyboardBackspaceOutlined } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";
import getChangedFeaturesList from "shared/common/utils/layers/getChangedFeaturesList";

export default function DeleteFeature() {
  const { t } = useTranslation();

  const viewer = defaultStore((state) => state.viewer);
  const deleteFeatureWithID = defaultStore(
    (state) => state.deleteFeatureWithID
  );
  const changeDeleteFeatureWithID = defaultStore(
    (state) => state.changeDeleteFeatureWithID
  );
  const changeAlertDeleteFeature = defaultStore(
    (state) => state.changeAlertDeleteFeature
  );
  const changeAlertMessage = defaultStore((state) => state.changeAlertMessage);

  const changeFeatureTableAddedRows = sidebarStore(
    (state) => state.changeFeatureTableAddedRows
  );
  const changeSelectedTableRows = sidebarStore(
    (state) => state.changeSelectedTableRows
  );

  // accept delete feature attempt
  const deleteFeature = () => {
    if (!viewer || !deleteFeatureWithID) return;
    const layer = viewer.getScene().getLayerHandler().getActiveLayer();
    const feature = layer?.getFeatureById(deleteFeatureWithID);
    if (layer && feature) {
      layer.getLayerEditor().deleteFeatures([deleteFeatureWithID]);
      if (layer.getLayerEditor().featuresdelete.length > 0) {
        const deletedFeatures = layer.getLayerEditor().featuresdelete;
        //check if its deleted this feature and add it inside list by converting to feature from id
        if (deletedFeatures.includes(deleteFeatureWithID)) {
          changeFeatureTableAddedRows(getChangedFeaturesList(layer));
          feature.hide();
          layer.featureselector.removeFromSelection(deleteFeatureWithID);
          viewer.getScene().getToolHandler().removeSelectedFeature(feature);
          changeSelectedTableRows(undefined);
        }
      }
    } else {
      changeAlertMessage({
        message: t("alert_error.missing_id_delete_feature"),
        type: "error",
      });
    }
    changeDeleteFeatureWithID(undefined);
    changeAlertDeleteFeature(false);
  };

  // cancel delete feature attempt
  const cancelDelete = () => {
    changeDeleteFeatureWithID(undefined);
    changeAlertDeleteFeature(false);
  };

  return (
    <Box
      sx={{
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: "100",
        paddingTop: "15%",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "blackBackground.main",
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "fit-content",
          flexDirection: "column",
          paddingY: 2,
          paddingX: 4,
          margin: 2,
          gap: 2,
          backgroundColor: "white",
          borderRadius: "8px",
        }}
      >
        <Typography
          sx={{
            color: "darkblue.main",
          }}
        >
          {t("feature_alert.delete_message")} {deleteFeatureWithID} ?
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Button
            onClick={() =>
              monitor(
                apm,
                "cancel-delete-feature | Feature Table",
                cancelDelete
              )
            }
            variant="outlined"
            sx={{ color: "darkblue.main", borderColor: "darkblue.main" }}
          >
            <KeyboardBackspaceOutlined fontSize="small" />{" "}
            {t("feature_alert.delete_back_button")}
          </Button>
          <Button
            onClick={() =>
              monitor(apm, "delete-feature | Feature Table", deleteFeature)
            }
            variant="outlined"
            sx={{ color: "darkblue.main", borderColor: "darkblue.main" }}
          >
            <Delete fontSize="small" />{" "}
            {t("feature_alert.delete_delete_button")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
